import React from 'react'
import { useHistory } from 'react-router'

import NotFound from '../../components/molecules/NotFound'

import { ACCOUNT_KEY } from '../../providers/AccountProvider'
import { getMessageFromError } from '../../utilities'

const ErrorPage = () => {
  const history = useHistory(0)

  let errorMessage
  const obj = sessionStorage.getItem('caughtError')

  if (!obj) {
    errorMessage = 'Unknown Error'
  } else {
    const error = JSON.parse(obj)
    try {
      errorMessage = `Error Message: ${getMessageFromError(error)}`
    } catch (_) {
      errorMessage = error.message
    }
  }

  const goBack = () => {
    history.goBack()
  }

  const handleLogout = () => {
    localStorage.removeItem('session_user')
    localStorage.removeItem('session_token')
    localStorage.removeItem('version')
    localStorage.removeItem(ACCOUNT_KEY)
    window.location.href = '/login/'
  }

  return (
    <NotFound header='An Error Occurred' info={errorMessage}>
      {classes => (
        <p className={classes.info}>
          You can{' '}
          <span className={classes.back} onClick={goBack}>
            go back
          </span>{' '}
          or{' '}
          <span className={classes.back} onClick={handleLogout}>
            sign out
          </span>
        </p>
      )}
    </NotFound>
  )
}

export default ErrorPage
